import { ActivityService } from './../../Services/activity.service';
import { CourseriddenService } from '../../Services/courseridden.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';


@Component({
    selector: 'app-courseridden-user-list',
    template: require('./courseridden-user-list.component.html'),
    styles: [require('./courseridden-user-list.component.css')]
})
export class CourseriddenUserListComponent implements OnInit {
    coursesRidden: any[] = [];
    memberId: number = 0;
    currentTotalCourses = 0;
    currentTotalDist = 0;
    currentAvgSpeed = 0;
    currentYear = new Date().getFullYear();
    yearsBeingMember:number[] = []

    usersActivities: any[] = []
    totalActivities: number = 0;
    totalOther: number = 0;
    totalTT: number = 0;

    constructor(private route: ActivatedRoute, private courseRiddenService: CourseriddenService, private activityService: ActivityService) {
        route.params.subscribe(p => {
            if (p['id'])
                this.memberId = +p['id'];
            else
                this.memberId = 0;
        });
    }

    ngOnInit() {
        if (this.memberId > 0){
            this.courseRiddenService.getYearsForMember(this.memberId).subscribe( res => {
                this.yearsBeingMember = res.reverse();
                // this.currentYear = this.yearsBeingMember[this.yearsBeingMember.length - 1];
                this.currentYear = this.yearsBeingMember[0];
                this.getData()
            })
            
        }
    }

    private reset(){
        this.totalActivities = 0;
        this.totalOther = 0;
        this.totalTT = 0;
        this.currentTotalCourses = 0;
        this.currentTotalDist = 0;
        this.currentAvgSpeed = 0;
    }

    private getData(){
        this.reset()
        this.courseRiddenService.getAllUsersCoursesRidden(this.memberId, this.currentYear).subscribe(
            cr => {
                this.coursesRidden = cr;
                // console.log(this.coursesRidden);
                this.doCoursesRiddenCalculations();
            }
        );
        this.activityService.getAllUsersActivities(this.memberId, this.currentYear).subscribe(act => {
            this.usersActivities = act;
            this.doActivitiesCalculations();
        });
    }

    private doCoursesRiddenCalculations() {
        var sumspeed = 0;
        this.coursesRidden.forEach(element => {
            this.currentTotalCourses += 1;
            this.currentTotalDist = this.currentTotalDist + element.distance;
            sumspeed = sumspeed + element.average
        });
        this.currentAvgSpeed = +((sumspeed / this.currentTotalCourses).toFixed(2));
    }

    private doActivitiesCalculations() {
        this.usersActivities.forEach(element => {
            // console.log(element);
            this.totalActivities += 1
            if (element.kind.name == "Andere activiteit") this.totalOther += 1;
            if (element.kind.name == "Toertochten") this.totalTT += 1;
        });
    }

    yearSelected(){
        // console.log("year change");
        // console.log(this.currentYear);
        this.getData();
    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/courseridden-user-list/courseridden-user-list.component.ts